import React from 'react';

import {
  TemplateSection,
  TemplateAboutMe,
} from '@xing-com/crate-lebenslauf-components';
import { useReadVitaReactiveVariable } from '@xing-com/crate-lebenslauf-hooks';

export const useAboutMe = (): JSX.Element[] => {
  const [data, setData] = React.useState<JSX.Element[]>([]);
  const { cv } = useReadVitaReactiveVariable();

  React.useEffect(() => {
    const paragraphs = cv?.aboutMe
      ? cv?.aboutMe
          ?.split('\n')
          .map((paragraph, index) => (
            <TemplateAboutMe aboutMe={paragraph} key={index} />
          ))
      : [];

    setData(
      paragraphs.length
        ? [
            <div key="name">
              <TemplateSection name="aboutMe" />
              {paragraphs[0]}
            </div>,
            ...paragraphs.slice(1),
          ]
        : []
    );
  }, [cv?.aboutMe]);

  return data;
};
